import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyD-xrBbbhI4LVt7KWveaZ4hzsQ7qsAJUcY",
  authDomain: "spanish-books-co-1585502105544.firebaseapp.com",
  databaseURL: "https://spanish-books-co-1585502105544.firebaseio.com",
  projectId: "spanish-books-co-1585502105544",
  storageBucket: "spanish-books-co-1585502105544.appspot.com",
  messagingSenderId: "709607354669",
  appId: "1:709607354669:web:15cc9660abd8cbb3c923a4"
 };

export const app = firebase.initializeApp(config)
export const db = app.firestore()
